exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3mv0kTfik8KCa8UTj-aHw3{margin-right:1rem}._3mv0kTfik8KCa8UTj-aHw3 .ico{display:inline;font-size:1.2rem}._8BSGWVJbLGOCF3cqeRJfv{width:90%}._8BSGWVJbLGOCF3cqeRJfv .destination-info-detail{overflow-wrap:break-word;width:inherit}._8BSGWVJbLGOCF3cqeRJfv span{width:95%}\n", ""]);

// exports
exports.locals = {
	"addressIcon": "_3mv0kTfik8KCa8UTj-aHw3",
	"destinationInfo": "_8BSGWVJbLGOCF3cqeRJfv"
};